import React from "react";
import styled from "styled-components";

const StyledList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  height: 50%;
  justify-content: space-evenly;
  @media screen and (min-width: 1200px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
  }
`;

const StyledLink = styled.a`
  text-decoration: none;
  color: #fff;
  border: ${props => props?.border ? '2px solid #fff' : 'none'};
  border-radius: ${props => props.border ? '50px' : 'none'};
  padding: ${props => props.border ? '10px 30px' : '0'};
  @media screen and (min-width: 1200px) {
    padding-left: 30px ;
  }
`;


const Nav = () => (
  <StyledList>
    <StyledLink href={"/#"}>
      <li>Features</li>
    </StyledLink>
    <StyledLink href={"/#"}>
      <li>Products</li>
    </StyledLink>
    <StyledLink href={"/#"}>
      <li>Company</li>
    </StyledLink>
    <StyledLink href={"/#"}>
      <li>Pricing</li>
    </StyledLink>
    <StyledLink href={"/#"}>
      <li>Support</li>
    </StyledLink>
  </StyledList>
);
export default Nav;

